// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-container[data-v-f85fcbaa]{height:525px;width:calc(var(--inner-width)*1px);margin:0 auto}", ""]);
// Exports
module.exports = exports;
